<template>
    <div>

        <!-- Modal -->
        <div class="modal fade" id="selecionarRequisicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content bg-primary">
                    <div class="modal-header" v-if="dados">
                        <h5 class="modal-title text-white">Selecionar Requisição</h5>
                            <button type="button" class="close" @click="fechar()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="dados">
                            <div class="list-group" v-if="dados.requisicoes && dados.requisicoes.length">
                                <button type="button" class="list-group-item list-group-item-action"
                                    @click="selecionar_requisicao(requisicao)"
                                    v-for="(requisicao, irx) in dados.requisicoes" :key="irx">
                                    
                                    <div>{{ requisicao.anamnese.atendimento_procedimento.atendimento.medico.st_nome_exibicao }}</div>
                                    <div v-if="requisicao.doc_data">{{ requisicao.doc_data }}</div>
                                    <div v-if="requisicao.cid">{{ requisicao.cid.st_codigo }}</div>
                                    <div>
                                        <span class="badge badge-secondary mr-2">
                                            {{ requisicao.items.length }}
                                        </span>
                                        <small>
                                            {{ requisicao.lista_items }}
                                        </small>
                                    </div>

                                </button>
                            </div>
                            <div v-else>
                                Requisição não identificada.
                            </div>
                        </template>

                        <template v-else>
                            Carregando...
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() { 
        return { 
            dados: null, 
            origem: null, 
            lista: [], 
        }
    },
    
    methods: { 
        fechar () { 
            $('#selecionarRequisicaoModal').modal('hide');
        },

        selecionar_requisicao(requisicao) { 

            if ( process.env.VUE_APP_GTAG ) { 

                let action = 'requisicao-para-atendimento';
                let label = this.dados.id_marcacao;

                this.$gtag.event(action, {
                    'event_category': window.redir,
                    'event_label': label,
                    'value': 1
                });

            }

            if ( requisicao.doc_data ) { 
                this.origem.atendimento.dt_solicitacao = requisicao.doc_data.substr(6,4) + '-' + requisicao.doc_data.substr(3,2) + '-' + requisicao.doc_data.substr(0,2);
            } else { 
                this.origem.atendimento.dt_solicitacao = this.$util.hoje();
            }

            if ( !this.origem.id_requisicao ) { 
                this.origem.id_requisicao = requisicao.id_requisicao;
            }

            if ( this.$parent.$refs.medico_solic ) { 
                if ( requisicao.id_cid ) { 
                    this.$parent.$refs.medico_solic.definir_cid(requisicao.id_cid);
                }

                if ( _.get(requisicao, 'anamnese.atendimento_procedimento.atendimento.medico') ) { 
                    this.$parent.$refs.medico_solic.buscar_solicitante_pelo_executante(requisicao.anamnese.atendimento_procedimento.atendimento.medico);
                }
            }

            $('#selecionarRequisicaoModal').modal('hide');

            this.lista = requisicao.items;
            this.incluir_proximo();
            
            /*
            requisicao.items.forEach(item => {

                if ( this.dados.atendimento.atendimento_procedimentos.find(ap => ap.procedimento && ap.fl_ativo && !ap.excluido && ap.procedimento.id_procedimento == item.id_procedimento) )
                    return true;
 
                this.$parent.incluirProcedimento(item.item);
                
            });
            */
            
        },

        incluir_proximo () { 

            let novo = _.pullAt(this.lista, '0');    

            novo = _.get(novo, '0');

            if ( !novo )
                return;

            if ( this.dados.atendimento.atendimento_procedimentos.find(ap => ap.procedimento && ap.fl_ativo && !ap.excluido && ap.procedimento.id_procedimento == novo.id_procedimento) ) { 
                this.incluir_proximo();
                return;
            }
                
            this.$parent.incluirProcedimento(novo.item, this.incluir_proximo);
            
        },

        abrir(marcacao) { 
            if ( !marcacao ) { 
                alert('Problema na identificação da requisição.');
                return;
            }

            this.dados = _.cloneDeep(marcacao);
            this.origem = marcacao; 
            
            this.$nextTick(() => { 
                $('#selecionarRequisicaoModal').modal('show');
            });
        }

    }
}
</script>